import { CertificateSettingsContext, CustomerSettingsContext } from '@vcd-ecm-ui/Common';
import * as _ from 'lodash';
import { VtxColumnProps } from '@vertexinc/vtx-ui-react-component-library';
import { GenericGridRowData } from '../GenericGrid/Interfaces';

// eslint-disable-next-line import/prefer-default-export
export function GetActiveVertexColumns(
  defaultColumns: VtxColumnProps<GenericGridRowData>[],
  settingsContext: CertificateSettingsContext | CustomerSettingsContext,
  settingCustomField: string,
  customColumnPrefix: string,
): VtxColumnProps<GenericGridRowData> [] {
  const columns: VtxColumnProps<GenericGridRowData>[] = [];

  // Loop through the Columns
  defaultColumns.forEach((column: VtxColumnProps<GenericGridRowData>) => {
    const title: string = column.title as string;
    const translatedColumn = title.replace(customColumnPrefix, settingCustomField).replace(' ', '');

    // Look for the Custom Field Columns
    if (settingsContext && (translatedColumn in settingsContext)) {
      const newColumnName = settingsContext[translatedColumn];

      // Column is Enabled
      if (newColumnName) {
        const copyColumn: VtxColumnProps<GenericGridRowData> = _.cloneDeep(column);
        copyColumn.title = newColumnName as string;
        columns.push(copyColumn);
      }
    } else { // Other Columns
      columns.push(column);
    }
  });

  return columns;
}
